import { render, staticRenderFns } from "./InscripcionView.vue?vue&type=template&id=ee767142&scoped=true&lang=es"
import script from "./InscripcionView.vue?vue&type=script&lang=js"
export * from "./InscripcionView.vue?vue&type=script&lang=js"
import style0 from "./InscripcionView.vue?vue&type=style&index=0&id=ee767142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee767142",
  null
  
)

export default component.exports